<template>
  <div>
    <ParagraphBody>
      Go ahead and download the {{ label }} Agent now.
    </ParagraphBody>
    <IconButton
      :class="$style.downloadBtn"
      icon="fileDownload"
      :outline="true"
      :text="downloadText"
      type="secondary"
      @click="handleDownloadAgent"
    />
    <ParagraphBody
      bodySize="small"
      :class="$style.note"
      weight="light"
    >
      You must be the administrator on the device to run the installer.
    </ParagraphBody>
    <CompatibilityNotes
      :compatibilityNotes="compatibilityNotes"
    />
  </div>
</template>

<script>
import {
  IconButton,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import CompatibilityNotes from 'client/systems/CompatibilityNotes.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import Util from 'client/util/Util';

const {
  description,
  location,
  section,
  text,
} = eventProperties;

export default {
  name: 'AgentSetupIntro',

  components: {
    CompatibilityNotes,
    IconButton,
    ParagraphBody,
  },

  EventHelper,
  Util,

  props: {
    agentUrl: {
      required: true,
      type: String,
    },

    compatibilityNotes: {
      type: Object,
      required: true,
      validator(value) {
        if (!value) {
          return true;
        }

        return !!(value.header && value.text && value.kbLink
          && value.kbLink.text && value.kbLink.href);
      },
    },

    label: {
      type: String,
      default: '',
    },
  },

  computed: {
    downloadText() {
      return `Download ${this.label} Agent`;
    },
  },

  methods: {
    handleDownloadAgent() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'User downloaded the agent',
        [location]: eventLocations.immersiveOnboarding,
        [section]: `Device Setup - ${this.label} Install Manually`,
        [text]: this.downloadText,
      });

      this.$options.Util.openUrl(this.agentUrl);
    },
  },
};
</script>

<style scoped module>
@import './css/guided-setup.css';

.downloadBtn {
  margin-bottom: var(--jc-spacer);
  margin-top: var(--jc-spacer-large);
}

.note {
  padding-bottom: var(--jc-spacer-large);
}
</style>
